import DO_LOGIN from './DoLogin'
import DO_LOGOFF from './DoLogoff'
import DO_RELOGIN from './DoRelogin'
import FORCE_EXPIRE from './ForceExpire'

export default {
  DO_LOGIN,
  DO_LOGOFF,
  DO_RELOGIN,
  FORCE_EXPIRE
}



// WEBPACK FOOTER //
// ./src/view/login/state/action/index.js